// extracted by mini-css-extract-plugin
export default {"wrapper":"app_wrapper__sU+SW","card-wrapper":"app_card-wrapper__+4eOG"};